import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { dispatch as storeDispatch } from '@store';
import { actions } from '@store/popups';

/**
 * Popups controller.
 *
 * @author Mikhail Siutsou
 * @const PopupsServiceClass
 * @category Services
 * @subcategory Popups
 */
var PopupsServiceClass = /*#__PURE__*/function () {
  function PopupsServiceClass() {
    _classCallCheck(this, PopupsServiceClass);
  }

  _createClass(PopupsServiceClass, [{
    key: "open",
    value:
    /**
     * Open popup.
     *
     * @author Mikhail Siutsou
     * @param {string} popupId popupId.
     * @param {T} data popup data.
     * @return {void}
     */
    function open(popupId, data) {
      var dispatch = storeDispatch;
      var popupAction = dispatch(actions.popupInit({
        popupId: popupId,
        data: data,
        isOpen: true
      }));
      popupAction["catch"](function (error) {
        return error;
      });
      return popupAction;
    }
    /**
     * Close popup.
     *
     * @author Mikhail Siutsou
     * @param {string} popupId popupId.
     * @param {Dispatch} dispatch dispatch.
     * @return {void}
     */

  }, {
    key: "close",
    value: function close(popupId) {
      storeDispatch(actions.popupInitClosing({
        popupId: popupId
      }));
    }
    /**
     * Close all modals.
     *
     * @author Ihar Kazlouski
     * @param {Dispatch} dispatch dispatch.
     * @return {void}
     */

  }, {
    key: "closeAll",
    value: function closeAll() {
      storeDispatch(actions.popupInitCloseAll());
    }
    /**
     * Close popup with answer.
     *
     * @author Mikhail Siutsou
     * @param {string} popupId popupId.
     * @param {Dispatch} dispatch dispatch.
     * @param {object} answer answer.
     * @return {void}
     */

  }, {
    key: "closeWithAnswer",
    value: function closeWithAnswer(popupId, _ref) {
      var _ref$accepted = _ref.accepted,
          accepted = _ref$accepted === void 0 ? false : _ref$accepted,
          _ref$rejected = _ref.rejected,
          rejected = _ref$rejected === void 0 ? false : _ref$rejected;
      storeDispatch(actions.popupInitClosingWithAnswer({
        popupId: popupId,
        accepted: accepted,
        rejected: rejected
      }));
    }
  }]);

  return PopupsServiceClass;
}();

var PopupsService = new PopupsServiceClass();
export { PopupsService };